import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '@/assets/styles.scss';
import 'primeicons/primeicons.css';
import VueGtag, { trackRouter } from 'vue-gtag-next'

import App from './App.vue';
import router from './router';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(VueGtag, {
  property: {
    id: 'G-1B7WSVLS9P'
  }
})

router.isReady().then(() => {
  trackRouter(router)
})

app.mount('#app');
